module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "value": this.$route.query.status,
      "placeholder": "请选择状态"
    },
    on: {
      "input": _vm.statusChange
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('page-table', {
    attrs: {
      "data-api": this.api.activity,
      "viewable": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "编号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "活动名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startDate",
      "label": "活动日期",
      "formatter": function(row) {
        return row.startDate + ' 至 ' + row.endDate
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "viewer",
      "label": "浏览量",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          style: ({
            color: _vm.getStatusColor(scope.row.status)
          })
        }, [_vm._v(_vm._s(scope.row.status))])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a3d0712","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/activity/List.vue
// module id = 1188
// module chunks = 2